import { getLogger } from "@expert/logging";
import { Button, type ButtonProps, Text } from "@mantine/core";
import { withClickAnalytics } from "@soluto-private/eventualize-react";
import { useMutation } from "@tanstack/react-query";
import { useAgentSdk } from "@/sdk";
import type { ChatTask } from "@/sdk/agent/chat";

const AnalyticButton = withClickAnalytics(Button<"button">, "Click");
const logger = getLogger({ module: "EndChatButton" });

export default function EndChatButton({
    chatTask,
    size = "sm",
}: {
    chatTask: ChatTask;
} & ButtonProps) {
    const agentSdk = useAgentSdk();

    const { isPending, mutateAsync: startChatTaskWrapup } = useMutation({
        mutationFn: async () => {
            if (chatTask.status === "assigned") {
                await agentSdk.wrapupTask(chatTask, "CompletedByExpert");
            } else {
                logger.error("Task is in an invalid state to end chat");
            }
        },
    });

    return (
        <AnalyticButton
            analytics={{ actionId: "EndChatButton" }}
            id={`end-chat-button-chatId-${chatTask.chatId}`}
            aria-label="End chat"
            data-testid="end-chat-button"
            disabled={isPending || chatTask.status !== "assigned"}
            loading={isPending}
            size={size}
            color="red.9"
            onClick={() => void startChatTaskWrapup()}
        >
            <Text size="xs">End chat</Text>
        </AnalyticButton>
    );
}
